module.exports = __webpack_public_path__ + "media/logo/header-logo-000d49e3.svg";